"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var clsx_1 = __importDefault(require("clsx"));
var react_redux_1 = require("react-redux");
var reducers_1 = require("../../reducers");
require("./Forms.scss");
require("./CustomVirtualizedComboBox.scss");
var CustomLabel_1 = require("./CustomLabel");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var CustomVirtualizedComboBox = function (props) {
    var label = props.label, id = props.id, className = props.className, readOnly = props.readOnly, required = props.required, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, currentLang = props.currentLang, validationFunc = props.validationFunc, onValidationChange = props.onValidationChange, errorMessageFromProps = props.errorMessage, selectedKey = props.selectedKey, containerClassName = props.containerClassName, callOutWidth = props.callOutWidth, onRenderContainer = props.onRenderContainer;
    var fieldId = react_1.useState(id !== null && id !== void 0 ? id : react_2.getId('vc_'))[0];
    var _a = react_1.useState(), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = react_1.useState(undefined), isValid = _b[0], setIsValid = _b[1];
    var useClassName = clsx_1.default(className, readOnly ? 'eta-cVirtualizedComboBoxReadOnly' : '', currentLang.isRtl ? 'rtlFlag' : 'ltrFlag');
    var onChangeKey = react_1.useCallback(function (key) {
        var newIsValid = true;
        var previousError = errorMessage;
        if (errorMessageFromProps) {
            if (previousError !== errorMessageFromProps) {
                setErrorMessage(errorMessageFromProps);
            }
            //   newIsValid = false;
        }
        else if (validationFunc) {
            var error = validationFunc(key);
            if (previousError !== error) {
                setErrorMessage(error);
            }
            if (error) {
                newIsValid = false;
            }
        }
        if (newIsValid !== isValid) {
            setIsValid(newIsValid);
            if (newIsValid) {
                if (previousError && !errorMessageFromProps) {
                    setErrorMessage(undefined);
                }
            }
            if (onValidationChange) {
                onValidationChange(newIsValid);
            }
        }
    }, [
        errorMessageFromProps,
        errorMessage,
        isValid,
        onValidationChange,
        validationFunc,
    ]);
    react_1.useEffect(function () {
        if (onValidationChange) {
            if (validationFunc) {
                var error = validationFunc(selectedKey);
                onValidationChange(error === undefined);
            }
            else {
                onValidationChange(true);
            }
        }
    }, [selectedKey, onValidationChange, validationFunc]);
    return (react_1.default.createElement("div", { className: clsx_1.default('eta-vertialFlexDiv', containerClassName) },
        label && (react_1.default.createElement(CustomLabel_1.Label, { required: required, toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label)),
        react_1.default.createElement(react_2.VirtualizedComboBox, __assign({}, props, { id: fieldId, className: useClassName, errorMessage: readOnly ? undefined : errorMessageFromProps !== null && errorMessageFromProps !== void 0 ? errorMessageFromProps : errorMessage, calloutProps: { className: callOutWidth !== 'Fixed' ? 'applyContentFit' : 'applyFixed' }, onRenderContainer: function (p, df) {
                var dd = document.getElementById(fieldId);
                document.body.style.setProperty('--currentEtaCombBoxMinSize', (dd === null || dd === void 0 ? void 0 : dd.clientWidth.toString()) + "px");
                if (onRenderContainer) {
                    return (onRenderContainer(p, df));
                }
                if (df) {
                    return (df(p));
                }
                return (null);
            }, required: undefined, label: undefined, allowFreeform: true, autoComplete: "on", onChange: function (e, key) {
                onChangeKey(key === null || key === void 0 ? void 0 : key.key);
                if (props.onChange) {
                    props.onChange(e, key);
                }
            } }))));
};
exports.default = connector(CustomVirtualizedComboBox);
//# sourceMappingURL=CustomVirtualizedComboBox.js.map